var BOT_USER_AGENTS = ['googlebot', 'google-structured-data-testing-tool', 'bingbot', 'linkedinbot', 'mediapartners-google'];
export default BOT_USER_AGENTS;